import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";

export function useAdminOrgContext() {
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null);

  const orgsQuery = useQuery({
    queryKey: ["admin_all_orgs"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("partner_orgs")
        .select("id, name, industry, is_auto_created")
        .order("name");
      if (error) throw error;
      return data;
    },
  });

  const orgs = orgsQuery.data ?? [];
  const orgId = selectedOrgId ?? orgs[0]?.id ?? null;
  const org = orgs.find((o) => o.id === orgId) ?? null;

  return {
    orgs,
    orgId,
    org,
    selectedOrgId,
    setSelectedOrgId,
    isLoading: orgsQuery.isLoading,
  };
}
